// extracted by mini-css-extract-plugin
export default {"TopicContainer":"Topic_TopicContainer__ltu2u"};